export const setMultiplataforma = (id) => {
  // Return action
  return {
    type: 'SET_MULTIPLATAFORMA',
	id: id
  }
};